import { render, staticRenderFns } from "./RankingCard.vue?vue&type=template&id=fcbf4dba&scoped=true&"
import script from "./RankingCard.vue?vue&type=script&lang=js&"
export * from "./RankingCard.vue?vue&type=script&lang=js&"
import style0 from "./RankingCard.vue?vue&type=style&index=0&id=fcbf4dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbf4dba",
  null
  
)

export default component.exports